import {Parameter, UrlConverter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalUrlConverterPage} from "./PortalUrlConverterPage";
import {PortalConverterHeaderFooter} from "./PortalConverterHeaderFooter";

export class PortalUrlConverter extends UrlConverter implements Parameter {
	public header?: PortalConverterHeaderFooter;
	public footer?: PortalConverterHeaderFooter;

	constructor(data: any) {
		super(data);

		this.page = PortalUrlConverterPage.fromJson(data?.page);
		this.header = PortalConverterHeaderFooter.fromJson(data?.header);
		this.footer = PortalConverterHeaderFooter.fromJson(data?.footer);
	}

	public static fromJson(data: any): PortalUrlConverter {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalUrlConverter(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'page': this.page?.toJson(),
			'header': this.header?.toJson(),
			'footer': this.footer?.toJson()
		};
	}

	public clone(): PortalUrlConverter {
		return PortalUrlConverter.fromJson(this.toJson());
	}
}